import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'statusIconMaintenance' })
export class StatusIconMaintenancePipe implements PipeTransform {

  transform(statusName: string): string {
    if (statusName) {
      if (statusName === 'new') {
        return 'add_circle_outline';
      } else if (statusName === 'pending') {
        return 'schedule_send';
      } else if (statusName === 'requested') {
        return 'email';
      } else if (statusName === 'onNegotiation') {
        return 'assignment_late';
      } else if (statusName === 'scheduled') {
        return 'scheduled';
      } else if (statusName === 'inProgress') {
        return 'location_on';
      } else if (statusName === 'done') {
        return 'done';
      } else if (statusName === 'canceled') {
        return 'close';
      }
    }
    return null;
  }
}
